export default {
  name: 'custom-scope-configuration',
  translationKey: 'custom-scope-configuration-module',
  routePrefix: 'custom-scope-configuration',
  routeNamePrefix: 'admin.custom-scope-configuration',
  directRoutesAvailable: false,
}
